import React from 'react';

const MyAccount = () => {
  return <h2>My Account Page</h2>;
};

export default MyAccount;
